import {headerSpanner, toggleReadmoreText} from './helpers';
import {toggleAccordion} from './helpers';
import {makeLastBold} from './helpers';
const menuOpened = new Event('menu-opened');

document.addEventListener('DOMContentLoaded', () => {
    // Dropdown Language Switcher
    const ls = document.querySelector('.js-dropdown-language-switcher');
    if (ls) {
        const lsToggle = ls.querySelector('.js-language-switcher-toggle');
        lsToggle.addEventListener('click', () => {
            ls.classList.toggle('active');
        });
    }

    let wordEls = document.querySelectorAll('.widget_mc4wp_form_widget h3');
    const wordList = [ ...wordEls, ...document.querySelectorAll('.product_title.entry-title') ];
    wordList.forEach((item, i) => {
      makeLastBold(item);
    });

    let headerEls = document.querySelectorAll('.js-chopped');
    const headerList = [ ...headerEls ];
    headerList.forEach((item, i) => {
      headerSpanner(item);
    });

});

if(jQuery('body').hasClass('page-template-template-services')){
    jQuery(window).scroll(function(){
    var x=window.pageYOffset;
    // console.log(x);
    scrollRotate();
    })

    function scrollRotate() {
        let shape1 = document.getElementById("image3");
        shape1.style.transform = "translateY(-" + window.pageYOffset/120 + "%)";
        let shape2 = document.getElementById("image2");
        shape2.style.transform = "translateY(-" + window.pageYOffset/80 + "%)";
        let shape3 = document.getElementById("image1");
        shape3.style.transform = "translateY(-" + window.pageYOffset/80 + "%)";
        let shape4 = document.getElementById("step_by_step");
        // shape4.setAttribute("style","height:calc(100vh - (" + window.pageYOffset/5 + "%))");
    }

}

/*Homepage Slider*/
import Swiper, { Navigation } from 'swiper';

// if($(".home #hero").length){
//     const home_gallery = new Swiper(".home_swipe", {
//         slidesPerView: "1",
//         centeredSlides: true,
//     });
// }

/* Featured home swipper */
if($(".home #featured").length || $(".page-template-template-services #featured").length){

    new Swiper(".featured_swipe", {
        slidesPerView: 1.5,
        grabCursor: true,
        navigation: {
            nextEl: ".arrows .next",
            prevEl: ".arrows .prev",
        },
        spaceBetween: 15,
        breakpoints: {
            1440: {
                slidesPerView: 3.5,
                spaceBetween: 70
            },
            991: {
                slidesPerView: 2.5,
                spaceBetween: 40
              }
          }
    });

    // fix last item height in featured slider
    var featSlHeight = $('#featured .featured_products .swiper-wrapper').outerHeight();
    $('#featured .featured_products .swiper-slide.last').css('min-height', featSlHeight);
};

if($(".page-template-template-showroom").length){
    $(".page-main p").attr('data-scroll', '');
    // $(".page-main p").attr('data-scroll-repeat', '');
    $(".page-main p").addClass('fadeit');
};

if($(".single.single-product").length){
    // $('.woocommerce div.product div.summary').attr('data-scroll', '');
    // $(".woocommerce div.product div.summary").attr('data-scroll-sticky', '');
    // $(".woocommerce div.product div.summary").attr('data-scroll-target', '.single-product__content');
    // $(".woocommerce div.product div.summary").addClass('fadeit');
};

if($(".page-template-template-press").length){
    $("#press .project_wrapper.main_column .project:first-child").attr('data-scroll-speed', '4');
    $("#press .project_wrapper.main_column .project:nth-child(4)").attr('data-scroll-speed', '4');
};

// if($(".woocommerce .products").length){

//     $( ".woocommerce .products li" ).each(function( index ) {
//         $(this).attr('data-scroll', '');
//         $(this).attr('data-scroll-speed', '1');
//     });
//     $( ".woocommerce .products li:nth-child(2n - 1)" ).each(function( index ) {
//         $(this).attr('data-scroll-speed', '1.5');
//     });
//     $('aside .wcpf-filter').attr('data-scroll', '');
//     $('aside .wcpf-filter').attr('data-scroll-sticky', '');
//     $('aside .wcpf-filter').attr('data-scroll-target', '.widget.woocommerce.wcpf_widget_filters');

// };



/*locomotivecroll init*/
import LocomotiveScroll from 'locomotive-scroll';

//locomotive scroll init - disable locomotive in product listing
if ($("body").is(".tax-product_cat, .woocommerce-shop")) {
    
    //wrap product page filter widgets in a container
    $('.berocket_single_filter_widget').wrapAll('<aside class="widget woocommerce wcpf_widget_filters"><div class="wcpf-filter"><div class="wcpf-filter-inner"></div></div></aside>');  
    
    //expand all levels of categories filters if in product categories
    $(".prod_cat_filter .bapf_body ul li .fa").parent('li').addClass('counted');
    //clean deeper child elements
    $(".prod_cat_filter .bapf_body ul li ul li").removeClass('counted');
    $(".prod_cat_filter .bapf_body ul li ul li ul li").removeClass('counted');

    if ( $(".prod_cat_filter .bapf_body ul li.counted").length <= 1 ) {
        $('.prod_cat_filter ul li ul').show();
        $(".prod_cat_filter .bapf_body ul[style*='display']").show();
        $(".prod_cat_filter .bapf_body ul li .fa").removeClass('fa-plus');
        $(".prod_cat_filter .bapf_body ul li .fa").addClass('fa-minus');
    }

    //main init
    const scroll = new LocomotiveScroll({
        el: document.querySelector('[data-scroll-container]'),
        smooth: false,
        /*Fix mobile*/
        getDirection: true,
        mobile: {
            breakpoint: 0,
            smooth: false,
            getDirection: true,
        },
        tablet: {
            breakpoint: 0,
            smooth: false,
            getDirection: true,
        },
    });
    //locomotive scroll body height observer
    new ResizeObserver(() => scroll.update()).observe(document.querySelector("[data-scroll-container]"));

    //fix mobile menu top position on page load
    setTimeout(function() { 
        var headHeight = $('.site-header__container').outerHeight();
        $('.site-header__menu--mobile').css('top', headHeight);
        $('.site-header .mini-cart-widget-outer-wrapper').css('top', headHeight);
    }, 150);

     //sticky header
     const header = document.getElementById('header');
     scroll.on('scroll',(instance)=>{
 
         //change mini cart top position based on header height
         var headHeight = $('.site-header__container').outerHeight();
         $('.site-header__menu--mobile').css('top', headHeight);
         $('.site-header .mini-cart-widget-outer-wrapper').css('top', headHeight);
 
         let headerHeight = header.getBoundingClientRect().height;
         if(instance.direction === 'down'){
             if(instance.scroll.y > 300){
                 header.classList.add('pinned');
                 $('#backtotop').addClass('show');
                 
                 if ($(window).width() > 991) {
                     if($(".single.single-product").length){
                         $('.single-product__content .entry-summary').addClass('sticky');
                     };
                 }
             }
         }
         if(instance.direction === 'up'){
             if(instance.scroll.y <= 300){
                 header.classList.remove('pinned');
                 $('#backtotop').removeClass('show');
 
                 if ($(window).width() > 991) {
                     if($(".single.single-product").length){
                         $('.single-product__content .entry-summary').removeClass('sticky');
                     };
                 }
             }
         }
     });

    //back to top button
    $("#backtotop").click (function(e) {
        e.preventDefault()
        let target = e.target.getAttribute("href")
        console.log(target)
        scroll.scrollTo(target);
    });

    document.addEventListener('click', (event) => {
        // Toggle mobile menu Button
        if (event.target.matches('.js-menu-toggle')) {
            document.body.classList.toggle('menu-open');
            if (document.body.classList.contains('menu-open')) {
                document.dispatchEvent(menuOpened);
                scroll.stop();
            }else{
                scroll.start();
            }
            // close search widget and mini cart widget if they are open
            document.body.classList.remove('product-search-active');
            document.body.classList.remove('mini-cart-active');
        }
    });

    //disable locomotive scroll if scrolled inside minicart
    $('body').on("mouseenter touchstart", ".mini-cart-widget-wrapper", function(){
        scroll.stop();
    });
    $('body').on("mouseleave touchend", ".mini-cart-widget-wrapper", function(){
        scroll.start();
    }); 

    //scroll to top after woocommerce pagination click
    $(".woocommerce").on("click", ".woocommerce-pagination li", function(e) {
        // let target = document.getElementById("main");
        // scroll.scrollTo(target);
        
        var pageNum = $(this).find('a').attr('href');
        window.location.href = pageNum;
    });


    function customwoofilters() {
            
        //generate custom woocommerce dropdown
        $(function(){
            var id = "orderby";
            $('.'+id).after("<ul id='customsort' />")
                .children("option").each(function() {
                    var theval = $(this).attr('value');
                    $("#customsort").append("<li data-val='"+theval+"'><span>"+$(this).text()+"</span></li>");
                })
                .end();
            $('#customsort').attr("id",id);
            $('#orderby').wrap("<div class='customsort_wrap'></div>");

            var defaultoption = $('.woocommerce-ordering select').find(":selected").text();
            $('#orderby li:first-child').hide();
            $('.customsort_wrap').prepend("<div class='title'>"+defaultoption+"</div>");
        });

    }

    customwoofilters();
    
    //custom woocommerce sort dropdown actions
    $(".woocommerce").on("click", "#orderby li span", function(e) {
        var theval = $(this).parent('li').attr('data-val');       
        $(".woocommerce-ordering select option").prop("selected", false);
        $(".woocommerce-ordering select option[value='"+theval+"']").prop("selected", true);
        $(".woocommerce-ordering").submit();
    });
    //custom woocommerce main button
    $(".woocommerce").on("click", ".customsort_wrap .title", function() {
        $(this).toggleClass('clicked');
        $("#orderby").fadeToggle("fast");
    });
    //custom woocommerce li click function
    $(".woocommerce").on("click", ".customsort_wrap ul li", function() {
        $('.customsort_wrap ul li').removeClass('clicked');
        $(this).toggleClass('clicked');
    }); 
    //hide dropdown if clicked outside
    $(document).mouseup(function(e) 
    {
        var container = $(".customsort_wrap");
        if (!container.is(e.target) && container.has(e.target).length === 0) 
        {
            $("#orderby").hide();
            $(".customsort_wrap .title").removeClass('clicked');
        }
    });

    //woocommerce after ajax call (pagination, filters click) function
    (function() {
        const send = XMLHttpRequest.prototype.send
        XMLHttpRequest.prototype.send = function() { 
            this.addEventListener('load', function() {
                //console.log('global handler', this.responseText)
                // console.log('ajax complete'); 

                customwoofilters();

            })
            return send.apply(this, arguments)
        }
    })();
    
    $(window).on("load", function() {
        scroll.update();
        // console.log('window loaded');
    });

 }
 else{

    // main init
    const scroll = new LocomotiveScroll({
        el: document.querySelector('[data-scroll-container]'),
        smooth: true,
        /*Fix mobile*/
        getDirection: true,
        mobile: {
            breakpoint: 0,
            smooth: false,
            getDirection: true,
        },
        tablet: {
            breakpoint: 0,
            smooth: false,
            getDirection: true,
        },
    });
 
    //locomotive scroll body height observer
    new ResizeObserver(() => scroll.update()).observe(document.querySelector("[data-scroll-container]"));

    //fix mobile menu top position on page load
    setTimeout(function() { 
        var headHeight = $('.site-header__container').outerHeight();
        $('.site-header__menu--mobile').css('top', headHeight);
        $('.site-header .mini-cart-widget-outer-wrapper').css('top', headHeight);
    }, 150);

     //sticky header
     const header = document.getElementById('header');
     scroll.on('scroll',(instance)=>{
 
         //change mini cart top position based on header height
         var headHeight = $('.site-header__container').outerHeight();
         $('.site-header__menu--mobile').css('top', headHeight);
         $('.site-header .mini-cart-widget-outer-wrapper').css('top', headHeight);
 
         let headerHeight = header.getBoundingClientRect().height;
         if(instance.direction === 'down'){
             if(instance.scroll.y > 300){
                 header.classList.add('pinned');
                 $('#backtotop').addClass('show');
 
                 if ($(window).width() > 991) {
                    if($(".single.single-product").length){
                        $('.single-product__content .entry-summary').addClass('sticky');
                    };
                }
             }
         }
         if(instance.direction === 'up'){
             if(instance.scroll.y <= 300){
                 header.classList.remove('pinned');
                 $('#backtotop').removeClass('show');
                 
                 if ($(window).width() > 991) {
                    if($(".single.single-product").length){
                        $('.single-product__content .entry-summary').removeClass('sticky');
                    };
                }
             }
         }
     });

    //back to top button
    $("#backtotop").click (function(e) {
        e.preventDefault()
        let target = e.target.getAttribute("href")
        console.log(target)
        scroll.scrollTo(target);
    });

    document.addEventListener('click', (event) => {
        // Toggle mobile menu Button
        if (event.target.matches('.js-menu-toggle')) {
            document.body.classList.toggle('menu-open');
            if (document.body.classList.contains('menu-open')) {
                document.dispatchEvent(menuOpened);
                scroll.stop();
            }else{
                scroll.start();
            }
            // close search widget and mini cart widget if they are open
            document.body.classList.remove('product-search-active');
            document.body.classList.remove('mini-cart-active');
        }
    });

    //disable locomotive scroll if scrolled inside minicart
    $('body').on("mouseenter", ".mini-cart-widget-wrapper", function(){
        scroll.stop();
    });
    $('body').on("mouseleave", ".mini-cart-widget-wrapper", function(){
        scroll.start();
    }); 

    //disable locomotive scroll if scrolled inside product details
    if ($(window).width() > 991) {
        $('body.woocommerce').on("mouseenter", "div.product div.summary.sticky", function(){
            scroll.stop();
        });
        $('body.woocommerce').on("mouseleave", "div.product div.summary", function(){
            scroll.start();
        }); 
    }

    $(window).on("load", function() {
        scroll.update();
    });
   
 } 


// Document click listener
document.addEventListener('click', (event) => {
   
    // Site search Toggle Button
    if (event.target.matches('.js-product-search-toggle')) {
        document.body.classList.toggle('product-search-active');
    }
    else if (event.target.parentElement.classList.contains('js-product-search-toggle')) {
        document.body.classList.toggle('product-search-active');
    }
    else if (event.target.parentElement.parentElement.classList.contains('js-product-search-toggle')) {
        document.body.classList.toggle('product-search-active');
    }
    // Mini cart Toggle and Close Buttons
    else if (event.target.matches('.js-cart-toggle')) {
        document.body.classList.toggle('mini-cart-active');
    }
    else if (event.target.parentElement.classList.contains('js-cart-toggle')) {
        document.body.classList.toggle('mini-cart-active');
    }
    else if (event.target.parentElement.parentElement.classList.contains('js-cart-toggle')) {
        document.body.classList.toggle('mini-cart-active');
    }
    else if (event.target.matches('.js-cart-close')) {
        document.body.classList.remove('mini-cart-active');
    }
    else if (event.target.matches('.js-accordion-toggle')) {
        toggleAccordion(event.target);
    }
    // else if (event.target.classList.contains('js-readmore-btn')) {
    //     event.target.querySelector('.js-readmore').classList.toggle('hidden');
    //     event.target.querySelector('.js-readless').classList.toggle('hidden');
    //     toggleReadmoreText( event.target.parentElement );
    // }
    // else if (event.target.parentElement.parentElement.classList.contains('js-readmore-btn')) {
    //     event.target.parentElement.parentElement.querySelector('.js-readmore').classList.toggle('hidden');
    //     event.target.parentElement.parentElement.querySelector('.js-readless').classList.toggle('hidden');
    //     toggleReadmoreText( event.target.parentElement.parentElement.parentElement );
    // }
});

$(".js-readmore-btn" ).on("click", function() {
    //var morePar = $(this).parents('js-readmore-cont');
    $(this).parent().find('.plain-par__part--hidden p').toggleClass('js-hidden');
    $(this).find('.readmore-btn').toggleClass('clicked');
});

/* homepage scrolling text - script loads in functions.php */
if($(".text-loop").length){
    marqueeInit({
        uniqueid: 'mycrawler',
        style: {
            'padding': '5px',
            'width': '100%'
        },
        inc: 1, //speed - pixel increment for each iteration of this marquee's movement
        mouse: false
    });
}

//projects title split fonts
if($("#projects_content").length){
    $('#projects_content .small_wrapper.flex_wrapper .title h1').each(function(index, element) {
        var heading = $(element), word_array, last_word, first_part;
        word_array = heading.html().split(/\s+/); // split on spaces
        last_word = word_array.pop();             // pop the last word
        first_part = word_array.join(' ');        // rejoin the first words together
        heading.html(['<span class="title--center">',first_part, ' </span><span class="title--center">', last_word, '</span>'].join(''));

        //hide empty spans
        var checkempty = $(this).find('span:first-child').text();
        if(checkempty == ' '){
            $(this).find('span:first-child').hide();
        }
    });
} 

if($(".page-template-template-contact").length){
    $('.contact_info h1').each(function(index, element) {
        var heading = $(element), word_array, last_word, first_part;
        word_array = heading.html().split(/\s+/); // split on spaces
        last_word = word_array.pop();             // pop the last word
        first_part = word_array.join(' ');        // rejoin the first words together
        heading.html([first_part, '<span class="title--center">', last_word, '</span>'].join(''));
    });
}  

if($(".woocommerce-cart, .woocommerce-wishlist, .woocommerce-checkout, .woocommerce-account").length){
    $('h1.page-title').each(function(index, element) {
        var heading = $(element), word_array, last_word, first_part;
        word_array = heading.html().split(/\s+/); // split on spaces
        last_word = word_array.pop();             // pop the last word
        first_part = word_array.join(' ');        // rejoin the first words together
        heading.html(['<span class="title--center">',first_part, ' </span><span class="title--center">', last_word, '</span>'].join(''));

        //hide empty spans
        var checkempty = $(this).find('span:first-child').text();
        if(checkempty == ' '){
            $(this).find('span:first-child').hide();
        }
    });

    $('.woocommerce-checkout #order_review_heading').prependTo('#order_review');     
} 

//product listing title
if($(".archive.woocommerce-shop, .archive.tax-product_cat").length){
    $('.woocommerce-products-header__title').each(function(index, element) {
        var heading = $(element), word_array, last_word, first_part;
        word_array = heading.html().split(/\s+/); // split on spaces
        last_word = word_array.pop();             // pop the last word
        first_part = word_array.join(' ');        // rejoin the first words together
        heading.html(['<span class="title--center">',first_part, ' </span><span class="title--center">', last_word, '</span>'].join(''));

        //hide empty spans
        var checkempty = $(this).find('span:first-child').text();
        if(checkempty == ' '){
            $(this).find('span:first-child').hide();
        }
    });
} 

//product page title
if($(".single.single-product").length){
    $('.product_title').each(function(index, element) {
        var heading = $(element), word_array, last_word, first_part;
        word_array = heading.html().split(/\s+/); // split on spaces
        last_word = word_array.pop();             // pop the last word
        first_part = word_array.join(' ');        // rejoin the first words together
        heading.html(['<span class="title--center">',first_part, ' </span><span class="title--center">', last_word, '</span>'].join(''));

        //hide empty spans
        var checkempty = $(this).find('span:first-child').text();
        if(checkempty == ' '){
            $(this).find('span:first-child').hide();
        }
    });

    //move wishlist button inside woo form
    $('button.single_add_to_cart_button').wrap('<div class="add-to-wrap"></div>');
    $('.single-product__content .yith-wcwl-add-to-wishlist').appendTo('form.cart .add-to-wrap');
} 

//remove hero template load animation for projects page
if($(".page-template-template-projects").length){
    $('#projects_content .flex_wrapper').removeClass('curtain-load');
}

//auto collapse product listing filters
if($(".post-type-archive-product").length){
    if ($(window).width() < 991) {
        $('.wcpf-field-item ').each(function() {
            $(this).addClass('wcpf-box-hide');
        });
    }
    $('.wcpf-field-item.wcpf-field-price-slider').addClass('wcpf-box-hide');
}

//change cursor inside bespoke section
if($("#bespoke").length){
    const cursor = document.querySelector(".cursor");
    const thediv = document.getElementById("bespoke");

    thediv.addEventListener("mousemove", (e) => { 
        var parentOffset = $('.cursor').parent().offset(); 
        var relX = e.pageX - parentOffset.left;
        var relY = e.pageY - parentOffset.top;
        
        setTimeout(function() { 
            $(".cursor").css({
                left: relX,
                top: relY
            });
        }, 50);
    });
}

//custom animated hero cursor
if($(".home").length || $(".page-template-template-services").length ){

    if ($(window).width() > 991) {
        const cursor = document.querySelector("#hero .hero-image a");
        const thediv = document.getElementById("hero");

        thediv.addEventListener("mousemove", (e) => { 
            var parentOffset = $('#hero .hero-image a').parent().offset(); 
            var relX = e.pageX - parentOffset.left;
            var relY = e.pageY - parentOffset.top;
            
            setTimeout(function() { 
                $("#hero .hero-image a").css({
                    left: relX,
                    top: relY
                });
            }, 50);
        });
    }

}

//header icon-menu functions
$('.language-switcher').prependTo('.site-header__container .site-header__icon-menu');
$('.language-switcher').show();
$('.site-header__mobile-container').insertAfter('.site-header__icon-menu');


//home hero loading animation
if($(".home #hero").length || $(".page-template-template-services #hero").length){
    setTimeout(function() { 
        $('#hero .hero-image .paral-container .paral-bg').show();
        $('#hero .hero-image h1').show();
        $('h1, h2').addClass('noshadow');
        
    }, 1000);
    setTimeout(function() { 
        $('#hero .hero-image').addClass('loaded');
        $('#hero .hero-image h1').addClass('loaded');
    }, 1300);

    //home slider video button
    var sliderBtn = $('#hero .hero-image a').attr("href");
    if (sliderBtn == "#play") {
        $('#hero .hero-image a').on('click', function(e) {

            //lazyload the video
            $('#hero .hero-image .paral-container video').on('loadstart', function (event) {
                $(this).addClass('loading');
                $('#hero .hero-image .paral-container .spinner').removeClass('hidden');
            });
            $('#hero .hero-image .paral-container video').on('canplay', function (event) {
                $(this).removeClass('loading');
                $('#hero .hero-image .paral-container .spinner').addClass('hidden');
            });
            
            // $('#hero .hero-image a .play').addClass('hidden');
            // $('#hero .hero-image a .pause').removeClass('hidden');
            // setTimeout(function() { 
            //     $('#hero .hero-image a .play').removeClass('hidden');
            //     $('#hero .hero-image a .pause').addClass('hidden');
            // }, 200);
            
            //play-pause video functions
            if ($("#hero .hero-image .paral-container video").get(0).paused) {
                var url = $("#hero .hero-image .paral-container video source").attr('data-src');
                $("#hero .hero-image .paral-container video source").attr('src', url);
                $("#hero .hero-image .paral-container video").trigger('load');
                $("#hero .hero-image .paral-container video").trigger('play');

                $("#hero .hero-image .paral-container video").fadeIn();
                $("#hero .hero-image .paral-container .paral-bg").hide();

                $('#hero .hero-image h1').addClass('hide');
            } else {
                $("#hero .hero-image .paral-container video").trigger('pause');
                $("#hero .hero-image .paral-container video").hide();
                $("#hero .hero-image .paral-container img").fadeIn();
                $('#hero .hero-image h1').removeClass('hide');

            }

            $(this).toggleClass('clicked');
            e.preventDefault();
        });
    }

}
else if($(".curtain-load").length){
    setTimeout(function() { 
        $('.curtain-load h1').show();
        $('h1, h2').addClass('noshadow');
        $('.curtain-load .paral-bg').show();
        
    }, 1000);
    setTimeout(function() { 
        $('.curtain-load').addClass('loaded');
        $('.curtain-load h1').addClass('loaded');

        setTimeout(function() { 
            $('.curtain-load .subtle-cont').removeClass('hide');
        }, 1400);
       
    }, 1300);
}
else{
    /* add effect pre-class on headings */
    $('h1, h2').addClass('noshadow');
}

//remove product list initial title - check functions.php
setTimeout(function() { 
    $('li.product h2.woocommerce-loop-product__title.noshadow').remove();
    // console.log('test');
}, 10);

//move icons menu for mobile view
if ($(window).width() < 660) {
    $('.site-header__icon-menu').addClass('main');
    $('.site-header__container .site-header__menu--mobile').prepend('<div class="site-header__icon-menu mobile"></div>');
    $('.site-header__icon-menu.main .language-switcher, .site-header__icon-menu.main .site-header__account-link, .site-header__icon-menu.main .site-header__site-search').appendTo('.site-header__icon-menu.mobile');

    setTimeout(function() { 
        $('.site-header__container div').css('opacity', '1');
    }, 100);
}

if ($(window).width() < 1024) {
    $('li.menu-item.menu-item-object-page.menu-item-has-children a').on('click', function() {
      
        if ($(this).parents('.sub-menu').length) {

        }
        else{
            return false;
        }

    });
   
}